export const PRICE_SOURCE_MANUAL = "manual";

export const normalizeMaterialKey = (material) => {
  return String(material || "")
    .toLowerCase()
    .replace(/^minecraft:/, "")
    .trim();
};

const numberOrNull = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) && numberValue >= 0 ? numberValue : null;
};

export const createManualPriceProvider = (manualPrices) => {
  const normalizedPrices = {};
  for (const [material, price] of Object.entries(manualPrices || {})) {
    const normalizedPrice = numberOrNull(price);
    if (normalizedPrice !== null) {
      normalizedPrices[normalizeMaterialKey(material)] = normalizedPrice;
    }
  }

  return {
    source: PRICE_SOURCE_MANUAL,
    getPrice(material) {
      const normalizedMaterial = normalizeMaterialKey(material);
      return normalizedMaterial in normalizedPrices ? normalizedPrices[normalizedMaterial] : null;
    },
  };
};
